import { AppModal } from "./AppModal";
import { useFeedbackModal } from "@/hooks/use-feedback-modal";
import { useSession } from "@/hooks/useSession";
import { ThumbsUp, ThumbsDown, Loader2 } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";

export const FeedbackModal = () => {
  const { ratedSessionIds, closeFeedbackModal } = useFeedbackModal();
  const { rateSessions } = useSession();

  const [isPendingUp, setIsPendingUp] = useState(false);
  const [isPendingDown, setIsPendingDown] = useState(false);

  const postFeedback = async (isPositive: boolean) => {
    if (!ratedSessionIds) return;
    const setPending = isPositive ? setIsPendingUp : setIsPendingDown;
    setPending(true);
    await rateSessions(ratedSessionIds, isPositive ? 1 : 0);
    setPending(false);
    closeFeedbackModal();
  };

  return (
    <AppModal
      isOpen={!!ratedSessionIds && ratedSessionIds.length > 0}
      onOpenChange={() => closeFeedbackModal()}
      title="Feedback"
      description="Please provide feedback on your last sessions."
      disabled={isPendingUp || isPendingDown}
      footer={
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
          <Button variant="outline" onClick={() => postFeedback(false)} disabled={isPendingDown}>
            <ThumbLabel isPending={isPendingDown} thumb="down" />
          </Button>
          <Button variant="outline" onClick={() => postFeedback(true)} disabled={isPendingUp}>
            <ThumbLabel isPending={isPendingUp} thumb="up" />
          </Button>
        </div>
      }
    />
  );
};

const ThumbLabel = ({ isPending, thumb }: { isPending: boolean; thumb: "up" | "down" }) => {
  return isPending ? (
    <Loader2 className="w-4 h-4 animate-spin mx-4" />
  ) : thumb === "up" ? (
    <ThumbsUp className="w-4 h-4 mx-4" />
  ) : (
    <ThumbsDown className="w-4 h-4 mx-4" />
  );
};
